// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"84":"99651b0a5795c40c","155":"ab1e03b2546e71af"}[chunkId] + ".js";
};